/**
 * Task 15 — Supabase browser client (anon key + RLS).
 * Service-role keys must never enter this module or the client bundle.
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

export type CardZappSupabaseEnv = {
  url: string;
  anonKey: string;
};

export function readSupabaseEnv(
  env: Record<string, string | undefined> = import.meta.env,
): CardZappSupabaseEnv {
  const url = env['VITE_SUPABASE_URL'];
  const anonKey = env['VITE_SUPABASE_ANON_KEY'];
  if (url === undefined || url.trim() === '') {
    throw new Error('VITE_SUPABASE_URL is missing');
  }
  if (anonKey === undefined || anonKey.trim() === '' || anonKey.startsWith('replace-with-')) {
    throw new Error('VITE_SUPABASE_ANON_KEY is missing');
  }
  return { url: url.replace(/\/rest\/v1\/?$/, '').replace(/\/$/, ''), anonKey };
}

export function createCardZappSupabaseClient(
  env: CardZappSupabaseEnv = readSupabaseEnv(),
): SupabaseClient {
  // createClient generics default to `any` Database; cast keeps our surface typed without
  // generating a full Database schema in Task 15.
  return createClient(env.url, env.anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }) as SupabaseClient;
}
